import React from 'react';
import { Helmet } from 'react-helmet';

const MetaPixel = () => {
	// Check if we’re running on localhost
	const isLocal = window.location.hostname === 'localhost';

	// If on localhost, append test code; otherwise, leave blank
	const testCodeParam = isLocal ? '?test_event_code=TEST15922' : '';
	const testCodeParamNoscript = isLocal ? '&test_event_code=TEST15922' : '';

	return (
		<Helmet>
			<script id="facebook-pixel-script" type="text/javascript">
				{`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          // Append the test_event_code only if we're local
          t.src=v + '${testCodeParam}';
          s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '1324637198378049');
          fbq('track', 'PageView');
        `}
			</script>
			<noscript id="facebook-pixel-image">
				{`<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=1324637198378049&ev=PageView&noscript=1${testCodeParamNoscript}"
        />`}
			</noscript>
		</Helmet>
	);
};

export default MetaPixel;
